<template>
    <ToastNotification
        :message="toastMessage"
        :background-class="toastBackgroundClass"
        @closed="toastMessage = ''"
    />
    <section class="fixed w-full bg-bkg  top-0 shadow-light dark:shadow-dark z-50">
        <div class="py-2.5 container mx-auto">
            <logo-component :display_moto="true" />
        </div>
    </section>
    <div class="flex items-center justify-center min-h-screen bg-gray-100">
        <div class="bg-white p-8 rounded-lg shadow-light dark:shadow-dark w-full max-w-5xl" :class="{'grid sm:grid-cols-2 gap-4': isInviteValid}">
            <slot v-if="!loading">
                <div v-if="isInviteValid" class="hidden sm:block">
                    <h1 class="text-3xl font-bold mb-4">Welcome to Our Platform</h1>
                    <p class="mb-4">You have been invited to join our platform. Please fill out the form to complete your registration.</p>
                </div>
                <div v-if="isInviteValid">
                    <h2 class="text-2xl font-bold mb-4">Complete Your Registration</h2>
                    <form @submit.prevent="submitForm">
                        <MazInput v-model="position" class="w-full mb-3" :disabled="true" :label="'Position'" />
                        <MazInput type="email" v-model="email" class="w-full mb-3" :disabled="true" :label="$t('reg_form.email')" />
                        <div class="mb-4">
                            <MazInput v-model="name" class="w-full" :required="true" :label="$t('name')" />
                        </div>
                        <div class="flex mb-3 gap-3">
                            <MazInput type="password" v-model="password" :required="true" :label="$t('reg_form.password')" />
                            <MazBtn size="sm" class="whitespace-nowrap" @click="generatePass">
                                <font-awesome-icon icon="fa-solid fa-key" /> {{ $t('generate_password') }}
                            </MazBtn>
                        </div>

                        <MazBtn @click="finishSignUp()" class="mt-3">{{ $t('sign_up') }}</MazBtn>
                    </form>
                </div>
                <div v-else>
                    <h2 class="text-2xl font-bold mb-4">Invalid or Expired Invite</h2>
                    <p class="mb-4">The invite link you used is no longer valid. Please contact your supervisor or support for assistance.</p>
                    <MazBtn @click="goToLandingPage" class="bg-button text-white py-2 px-4 rounded">Go to Landing Page</MazBtn>
                </div>
            </slot>
            <div v-if="loading" class="text-center p-10">
                <font-awesome-icon icon="fas fa-spinner" class="animate-spin text-2xl text-gray-500 dark:text-gray-200" />
            </div>
        </div>
    </div>
</template>

<script>
import { inviteVerify, signup_from_invite } from '@/api/api.js';
import logoComponent from '@/components/logo.vue';
import { useAuthStore } from '@/stores/auth';

export default {
    name: 'Invite',
    components: {
        logoComponent
    },
    data() {
        return {
            email: '',
            position: '',
            name: '',
            password: '',
            isInviteValid: false,
            toastMessage: '',
            toastBackgroundClass: 'bg-green-500',
            loading: true 
        };
    },
    async created() {
        console.log(this.$route.query.invite);
        const inviteHash = await this.$route.query.invite;

        if (inviteHash && inviteHash.length !== 64) {
            this.isInviteValid = false;
            console.log(inviteHash.length)
            return;
        }
        try {
            const response = await inviteVerify(this.$cookies.get('userToken'), this.$cookies.get('c_id'), inviteHash);
            if (response.success === false) {
                this.isInviteValid = false;
                return;
            }
            this.email = response.email;
            this.position = response.position;
            this.isInviteValid = true;
        } catch (error) {
            this.isInviteValid = false;
        } finally {
            this.loading = false;
        }
    },
    methods: {
        async authMemory(token) {
            this.$cookies.remove('c_id');
            this.$cookies.set('userToken', token, '14d');

            // Update the authentication store (if you’re using one, e.g., Pinia or Vuex)
            const authStore = useAuthStore(); // Adjust based on your store setup
            if (authStore && typeof authStore.initialize === 'function') {
                await authStore.initialize(); // Ensure the store fetches user data with the new token
            }

            if (this.isElectron && go_to_profile) {
                await this.$router.push({ name: 'Creators' });
            } else {
                await this.$router.push({ name: 'Profile' });
            }
        },
        async finishSignUp() {
            let r = await signup_from_invite(this.$cookies.get('userToken'), this.$cookies.get('c_id'), this.name, this.password, this.$route.query.invite);
            console.log(r);
            if (r.success === false) {
                this.toastMessage = r.message;
                this.toastBackgroundClass = 'bg-red-500';
                return;
            }
            if (r.token) {
                this.authMemory(r.token)
            } else {
                this.toastMessage = r.message;
                this.toastBackgroundClass = 'bg-red-500';
            }
        },
        generatePass() {
            this.password = Math.random().toString(36).slice(-6) + '-' + Math.random().toString(36).slice(-6);
        },
        submitForm() {
            // Handle form submission
        },
        goToLandingPage() {
            this.$router.push('/');
        },
    },
};
</script>